import {
  WIRCreateJourneyStepsKeys,
  WIRFinalWIRSectionKey,
  WIRFinalWIRSections,
} from 'pages/WellGuardian/WIR/wir.constants';
import { CountryData, WIR } from 'types/wellGuardian';

export const getFinalWirSections = (wir: WIR | null, country: string) => {
  if (country === CountryData.congo) {
    return (
      (wir &&
        Object.keys(WIRFinalWIRSections)
          .map(item => ({
            label: WIRFinalWIRSections[item as WIRFinalWIRSectionKey],
            value: item,
            phase: WIRCreateJourneyStepsKeys.CG_FINAL_WIR,
          }))
          .filter(stepItem => stepItem.label !== WIRFinalWIRSections.managerialSummary)) ??
      []
    );
  } else if (country === CountryData.angola) {
    return (
      (wir &&
        Object.keys(WIRFinalWIRSections)
          .map(item => ({
            label: WIRFinalWIRSections[item as WIRFinalWIRSectionKey],
            value: item,
            phase: WIRCreateJourneyStepsKeys.AG_FINAL_WIR,
          }))
          .filter(stepItem => stepItem.label !== WIRFinalWIRSections.assignInterventionSPDT)) ??
      []
    );
  } else if (country === CountryData.iraq) {
    return (
      (wir &&
        Object.keys(WIRFinalWIRSections)
          .map(item => ({
            label: WIRFinalWIRSections[item as WIRFinalWIRSectionKey],
            value: item,
            phase: WIRCreateJourneyStepsKeys.IRAQ_FINAL_WIR,
          }))
          .filter(stepItem => stepItem.label !== WIRFinalWIRSections.assignInterventionSPDT)) ??
      []
    );
  } else if (country === CountryData.argentina) {
    return (
      (wir &&
        Object.keys(WIRFinalWIRSections)
          .map(item => ({
            label: WIRFinalWIRSections[item as WIRFinalWIRSectionKey],
            value: item,
            phase: WIRCreateJourneyStepsKeys.ARGENTINA_FINAL_WIR,
          }))
          .filter(stepItem => stepItem.label !== WIRFinalWIRSections.assignInterventionSPDT)) ??
      []
    );
  } else {
    return (
      (wir &&
        Object.keys(WIRFinalWIRSections)
          .map(item => ({
            label: WIRFinalWIRSections[item as WIRFinalWIRSectionKey],
            value: item,
            phase: WIRCreateJourneyStepsKeys.FINAL_WIR,
          }))
          .filter(stepItem => stepItem.label !== WIRFinalWIRSections.assignInterventionSPDT)) ??
      []
    );
  }
};
